import { render, staticRenderFns } from "./TableMultiple.vue?vue&type=template&id=1e680d35&"
import script from "./TableMultiple.vue?vue&type=script&lang=js&"
export * from "./TableMultiple.vue?vue&type=script&lang=js&"
import style0 from "./TableMultiple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd,QCheckbox} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QTd,QCheckbox}, component.options.components || {})
